/* @flow */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  withMobileNav: false,
};

const navSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    registerMobileNav(state) {
      state.withMobileNav = true;
    },
    unRegisterMobileNav(state) {
      state.withMobileNav = true;
    },
  },
});

export const { registerMobileNav, unRegisterMobileNav } = navSlice.actions;

export default navSlice.reducer;
